import React from "react";

const PracticeLanguages = (props) => {
    if (props.languages === undefined || props.languages.length === 0) {
        return <p>No languages spoken</p>;
    }

    const languageItems = props.languages.map((language, index) => {
        return <li key={language.id}>{language.name}</li>;
    });
    
    return (
        <ul>
            {languageItems}
        </ul>
    );
};

export default PracticeLanguages;